import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-xl border-2 border-brand-ink bg-brand-red font-display font-bold uppercase leading-tight tracking-wide text-white text-center shadow-cta transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-brand-red-dark active:translate-y-[3px] active:shadow-cta-pressed';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-base',
    lg: 'px-4 py-3.5 text-lg sm:text-xl'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-197" data-mp="1h48ibj5h6ha0">
      {children}
    </a>;
}